import { useAvailableItems } from 'hooks';
import { defaultCropData } from '../config/defaultCropData';

export const useFilterDefaultCropData = ({ isVerticalMedia = false }) =>
    useAvailableItems(defaultCropData, { isVerticalMedia });
